var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pb-3 mb-3 scroll-height", attrs: { id: "" } },
    [
      _c("div", { staticClass: "main-content sub subcontent mb-3" }, [
        _c("div", { attrs: { id: "recaptchaContainer" } }),
        _vm._v(" "),
        _c("div", { staticClass: "content-header p-0" }, [
          _c("div", { staticClass: "w-100 mx-0" }, [
            _c("h1", [
              _vm._v(_vm._s(_vm._f("trans")("Metadata Info Of Your File"))),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "text-left" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._f("trans")(
                      "The following table contains all the exif data and metadata info we could extract from your file using our free online metadata and exif viewer."
                    )
                  ) +
                  "\n                "
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "alert alert-info d-flex flex-column metainfo" },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "The data shown is all the metadata we could automatically extract from your file."
                )
              )
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f("trans")("It may be neither complete nor adequate.")
              )
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "Metadata could have been changed or deleted in the past. Please be aware that the metadata is provided without liability."
                )
              )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showOutput
        ? _c(
            "div",
            { staticClass: "metadata-container" },
            [
              _c(
                "a",
                {
                  staticClass: "btn mb-3 btn-primary",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handlePdfDownload.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm._f("trans")("Save this data as PDF")))]
              ),
              _vm._v(" "),
              _vm._l(_vm.output, function (outerValue, outerKey) {
                return _c(
                  "div",
                  {
                    key: outerKey,
                    staticClass: "py-3 px-3 bg-white border br-8 mb-3",
                  },
                  _vm._l(outerValue, function (value, key) {
                    return _c(
                      "div",
                      { key: key, staticClass: "border-bottom" },
                      [
                        _vm.shouldRenderAsArray(value)
                          ? [
                              _c("ViewArrayElement", {
                                attrs: { "data-set": value, "parent-key": key },
                              }),
                            ]
                          : [
                              _c("ViewJsonSingleElement", {
                                attrs: { "data-set": value, "parent-key": key },
                              }),
                            ],
                      ],
                      2
                    )
                  }),
                  0
                )
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn mb-3 btn-primary",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handlePdfDownload.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm._f("trans")("Save this data as PDF")))]
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }